<template>
  <div id="app">
    <div class="af-wrapper">
      <h3>AES 工具</h3>
      <label class="af-show" @click="swapTexts">交换输入/输出</label>
      <div class="af-form">
        <div class="af-outer af-required">
          <div class="af-inner">
            <label for="key">Key</label>
            <input id="key" v-model.trim="key" type="text" placeholder="请输入密钥">
          </div>
        </div>
        <div class="af-outer">
          <div class="af-inner">
            <label for="iv">IV</label>
            <input id="iv" v-model.trim="iv" type="text" placeholder="可选，16 字节">
          </div>
        </div>
        <div class="af-outer af-required">
          <div class="af-inner">
            <label for="input">输入</label>
            <textarea id="input" v-model="sourceText" rows="6" class="textarea" placeholder="待加密或解密的内容"></textarea>
          </div>
        </div>
        <div class="af-outer">
          <div class="af-inner">
            <label for="output">输出</label>
            <textarea id="output" v-model="resultText" rows="6" class="textarea" readonly placeholder="结果会显示在这里"></textarea>
          </div>
        </div>
      </div>

      <div class="tc actions">
        <button class="btn f14 h30" @click="encrypt">AES 加密</button>
        <button class="btn f14 h30" @click="decrypt">AES 解密</button>
        <span class="tip" v-if="message">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import CryptoJS from 'crypto-js'

export default {
  name: 'App',
  data () {
    return {
      key: '',
      iv: '',
      sourceText: '',
      resultText: '',
      message: ''
    }
  },
  methods: {
    encrypt () {
      if (!this.validateInputs(true)) return
      try {
        const { key, iv } = this.getKeyIv()
        const encrypted = CryptoJS.AES.encrypt(this.sourceText, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        })
        this.resultText = encrypted.toString()
        this.message = '加密成功'
      } catch (e) {
        this.message = '加密失败：' + e.message
      }
    },
    decrypt () {
      if (!this.validateInputs(false)) return
      try {
        const { key, iv } = this.getKeyIv()
        const decrypted = CryptoJS.AES.decrypt(this.sourceText, key, {
          iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        })
        this.resultText = decrypted.toString(CryptoJS.enc.Utf8)
        this.message = '解密成功'
      } catch (e) {
        this.message = '解密失败：' + e.message
      }
    },
    getKeyIv () {
      const key = CryptoJS.enc.Utf8.parse(this.key)
      const iv = this.iv ? CryptoJS.enc.Utf8.parse(this.iv) : undefined
      return { key, iv }
    },
    validateInputs (needText) {
      if (!this.key) {
        this.message = '请填写密钥'
        return false
      }
      if (needText && !this.sourceText) {
        this.message = '请输入内容'
        return false
      }
      this.message = ''
      return true
    },
    swapTexts () {
      const tmp = this.sourceText
      this.sourceText = this.resultText
      this.resultText = tmp
    }
  }
}
</script>

<style scoped>
.actions {
  margin-top: 10px;
}
.actions .btn + .btn {
  margin-left: 12px;
}
.actions .tip {
  margin-left: 14px;
  color: #555;
  font-size: 13px;
}
.textarea {
  width: 64%;
  resize: vertical;
  min-height: 120px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue